import {mockScenarios} from "../data/scenarios";
import {mockRules} from "../data/rules";

export const getTransactionTypeLabel = (t: any, value: string) => {
    const map: Record<string, string> = {
        sales: t('TransactionTypes.sales'),
        void: t('TransactionTypes.void'),
        return: t('TransactionTypes.return'),
    };
    return map[value] || value;
};

export const getTenderTypeLabel = (t: any, value: string) => {
    const map: Record<string, string> = {
        cash: t('TenderTypes.cash'),
        credit_card: t('TenderTypes.credit_card'),
        foreign_currency: t('TenderTypes.foreign_currency'),
        check: t('TenderTypes.check'),
    };
    return map[value] || value;
};


export const getFieldLabel = (t:any, field: string) => {
    const fieldMap: Record<string, string> = {
        type: t('TransactionTypes.title'),
        total_gross_amount: t('TenderTypes.total_gross_amount'),
        tenderType: t('TenderTypes.title'),
        item_count: t('CustomTypes.item_count'),
        total_item_return_count: t('CustomTypes.total_item_return_count'),
        total_void_count: t('CustomTypes.total_void_count'),
        total_modification_count: t('CustomTypes.total_modification_count'),
        custom_reduction_count: t('CustomTypes.custom_reduction_count'),
        custom_credit_card_usage: t('CustomTypes.custom_credit_card_usage'),
        custom_loyalty_card_usage: t('CustomTypes.custom_loyalty_card_usage'),
        is_no_matching_sales: t('CustomTypes.is_no_matching_sales'),
        beginDateTime: t('CustomTypes.beginDateTime'),
        duration: t('CustomTypes.duration'),
        total_return_count: t('CustomTypes.total_return_count'),
        reduction_percentage: t('CustomTypes.reduction_percentage'),
        itemType: t('CustomTypes.itemType'),
        employee_reduction_amount: t('CustomTypes.employee_reduction_amount'),
        manager_reduction_amount: t('CustomTypes.manager_reduction_amount'),
    };
    return fieldMap[field] || field;
};

export const getOperatorLabel = (t:any, op: string) => {
    const opMap: Record<string, string> = {
        eq: t('LogicalExpressions.equals'),
        ne: t('LogicalExpressions.not_equals'),
        gt: t('LogicalExpressions.greater_than'),
        gte: t('LogicalExpressions.greater_than_or_equal'),
        lt: t('LogicalExpressions.less_than'),
        lte: t('LogicalExpressions.less_than_or_equal'),
        contains: t('LogicalExpressions.contains'),
        and: t('LogicalExpressions.and'),
        or: t('LogicalExpressions.or'),
    };
    return opMap[op] || op;
};
export const getValueLabel = (t:any, value: string) => {
    const valueMap: Record<string, string> = {
        return: t('TransactionTypes.return'),
        void: t('TransactionTypes.void'),
        sales: t('TransactionTypes.sales'),
        modification: t('TransactionTypes.modification'),
        reduction: t('TransactionTypes.reduction'),
        cash: t('TenderTypes.cash'),
        credit_card: t('TenderTypes.credit_card'),
        true:t('LogicalExpressions.true'),
        false:t('LogicalExpressions.false'),
    };
    return valueMap[value] || value;
}

export const getScenarioName = (scenarioId: string) => {
    const scenario = mockScenarios?.find((s: any) => s.id === scenarioId);
    return scenario ? scenario.name : scenarioId;
};

export const getRuleName = (ruleId: string) => {
    const rule = mockRules?.find((s: any) => s.id === ruleId);
    return rule ? rule.name : ruleId;
}